const RTL_LANGUAGE: string[] = [
  'ar',
  'he',
  'fa',
  'ur',
  'ps',
  'ckb',
  'yi',
  'dv',
  'sd',
  'arc',
  'mn',
  'ug',
  'ks',
] as const;
const constants = {
  APP_NAME: 'faqApp',
  ORIGIN: 'app_settings',
  WIDGET_ORIGIN: 'widget',
  DEFAULT_LANGUAGE: 'en',
  LAYOUT: {
    BASIC: 'basic',
    COLLAPSE: 'collapse',
    STRIPES: 'stripes',
  },
  HEIGHT_APP: {
    FIXED: 'fixed',
    ADJUST: 'adjust',
  },
  MAX_DIMENSION_SIZE: 300,
  DISPLAY_CATEGORIES: {
    ABOVE: 'above',
    TOP: 'top',
    SIDE: 'side',
  },
  DISPLAY_CONTENT: {
    SPLIT_INTO_CATEGORIES: 'splitIntoCategories',
    ONE_LIST_OF_QUESTIONS: 'oneListOfQuestions',
  },
  DISPLAY_CATEGORIES_CONTENT: {
    ALL_FAQS: 0,
    SPECIFIC_CATEGORIES: 1,
  },
  SPACES: {
    LOOSE: 'loose',
    TIGHT: 'tight',
  },
  ALIGNMENT: {
    RIGHT: 'right',
    CENTER: 'center',
    LEFT: 'left',
  },
  QUESTION_OPEN_ICON: {
    ARROW: 'arrow',
    PLUS: 'plus',
  } as const,
  SEARCH: {
    /** Debounce delay (ms) before propagating search term to context to reduce re-renders while typing */
    DEBOUNCE_MS: 300,
    /** Debounce delay (ms) before firing search API request */
    API_DEBOUNCE_MS: 300,
    /** Page size for initial search request (load more uses cursor) */
    INITIAL_LIMIT: 20,
  },
  RTL_LANGUAGE,
} as const;

export default constants;
